import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center bg-charcoal-950 overflow-hidden pt-20" data-id="element-180">
      {/* Background gradient/texture */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-charcoal-800 via-charcoal-950 to-charcoal-950 opacity-80" data-id="element-181"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-183">
          <h1 className="text-5xl md:text-7xl font-extrabold text-offwhite-50 tracking-tight leading-tight mb-6" data-id="element-184">
            Where Recovery Meets{' '}
            <span className="text-amber-500" data-id="element-185">Performance</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-186">
          <p className="text-lg md:text-2xl text-offwhite-200 mb-10 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-187">
            Modern physical therapy and performance coaching in Camarillo,
            CA—combining in-person care and personalized programming to help you
            build confidence, resilience, and get back to what matters most.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-188">
          <a href="https://calendly.com/dylanmclean-mcleanphysicaltherapy/consult-call" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-amber-500 hover:bg-amber-400 text-charcoal-950 px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-105 flex items-center justify-center gap-2" data-id="element-189">
            Book Your Free Consult
            <ArrowRightIcon size={20} data-id="element-190" />
          </a>
          <a href="#approach" className="w-full sm:w-auto text-offwhite-100 hover:text-amber-500 px-8 py-4 rounded-full font-semibold text-lg transition-colors" data-id="element-191">
            Learn More
          </a>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex flex-col items-center" data-id="element-192">
        <span className="text-offwhite-200 text-sm mb-2 uppercase tracking-widest" data-id="element-193">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-charcoal-800 relative overflow-hidden" data-id="element-194">
          <motion.div animate={{
          y: [0, 48, 0]
        }} transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'linear'
        }} className="absolute top-0 left-0 w-full h-1/2 bg-amber-500" data-id="element-195" />
        </div>
      </motion.div>
    </section>;
}